import {actions} from './actions';
import {getters} from './getters';
import {mutations} from './mutations';
import {state} from './state';

export const reports = {
  actions,
  getters,
  mutations,
  state,
  name: 'reports'
};
